import React from 'react';

type Branch = 'live_events' | 'studio' | 'outreach' | 'internal';

interface BranchTagProps {
  branch: Branch;
  size?: 'xs' | 'sm';
}

const BRANCH_CONFIG: Record<Branch, { label: string; className: string }> = {
  live_events: { label: 'Live Events', className: 'branch-live' },
  studio: { label: 'Studio', className: 'branch-studio' },
  outreach: { label: 'Outreach', className: 'branch-outreach' },
  internal: { label: 'Internal', className: 'branch-internal' },
};

export default function BranchTag({ branch, size = 'sm' }: BranchTagProps) {
  const config = BRANCH_CONFIG[branch];
  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-md
        ${config.className}
        ${size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-0.5'}
      `}
    >
      {config.label}
    </span>
  );
}